<ng-container *ngIf="amount?.errors as errors">
  <ng-container *ngIf="errors.required">
    Wpisz kwotę
  </ng-container>
  <ng-container *ngIf="errors.max"> Kwota nie może przekraczać {{ maxAmount | number: '1.2-2':'pl' }} zł </ng-container>
  <ng-container *ngIf="errors.min"> Minimalna kwota opłaty to {{ minAmount | number: '1.2-2':'pl' }} zł </ng-container>
</ng-container>
